import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import common from "./locales/en/common.json"
import messages from "./locales/en/messages.json"
import commonDa from "./locales/da/common.json"
import messagesDa from "./locales/da/messages.json"
import commonDe from "./locales/de/common.json"
import messagesDe from "./locales/de/messages.json"
import commonFr from "./locales/fr/common.json"
import messagesFr from "./locales/fr/messages.json"
import commonIt from "./locales/it/common.json"
import messagesIt from "./locales/it/messages.json"
import commonPl from "./locales/pl/common.json"
import messagesPl from "./locales/pl/messages.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common,
        messages,
      },
      da: {
        common: commonDa,
        messages: messagesDa,
      },
      de: {
        common: commonDe,
        messages: messagesDe,
      },
      fr: {
        common: commonFr,
        messages: messagesFr,
      },
      it: {
        common: commonIt,
        messages: messagesIt,
      },
      pl: {
        common: commonPl,
        messages: messagesPl,
      },
      es: {
        common,
        messages,
      },
    },
    supportedLngs: ["en", "da", "fr", "it", "es", "pl", "de"],
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: {
      // React already escapes rendered strings
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  })

export default i18n
